import React, { useState, useEffect } from "react";
import DateRangePicker from "../general/DateRangePicker";
import downloadIcon from "../../assets/img/ico/download.svg";
import "../../assets/css/mission-creation.css";
import { useNavigate } from 'react-router-dom';

const formatDate = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};

const MissionCreationForm = ({ currentStep: initialStep = 1 }) => {
    const [activeStep, setActiveStep] = useState(initialStep);
    const [direction, setDirection] = useState('next');
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [previousStep, setPreviousStep] = useState(null);
    const [showConfirmation, setShowConfirmation] = useState(false);

    const navigate = useNavigate();

    const [chosedMission, setChosedMission] = useState("Sélectionner une offre existante pour pré-remplir");
    const [missionDropdownOpen, setMissionDropdownOpen] = useState(false);
    const [selectedQualification, setSelectedQualification] = useState("Agent de nettoyage H/F");
    const [selectedAddress, setSelectedAddress] = useState("company");
    const [customAddress, setCustomAddress] = useState({
        lieu: "Entrepôt St Denis",
        adresse: "122 boulevard de Corbeilles",
        codePostal: "75017",
        ville: "Paris"
    });

    const [missionStartDate, setMissionStartDate] = useState(new Date(2025, 2, 23));
    const [missionEndDate, setMissionEndDate] = useState(new Date(2025, 2, 27));

    const [startTimeHour, setStartTimeHour] = useState("05h");
    const [startTimeMinute, setStartTimeMinute] = useState("30m");
    const [endTimeHour, setEndTimeHour] = useState("11h");
    const [endTimeMinute, setEndTimeMinute] = useState("00m");

    const [startTimeHourOpen, setStartTimeHourOpen] = useState(false);
    const [startTimeMinuteOpen, setStartTimeMinuteOpen] = useState(false);
    const [endTimeHourOpen, setEndTimeHourOpen] = useState(false);
    const [endTimeMinuteOpen, setEndTimeMinuteOpen] = useState(false);

    const [workingDays, setWorkingDays] = useState({
        Lundi: true,
        Mardi: true,
        Mercredi: false,
        Jeudi: false,
        Vendredi: false,
        Samedi: false,
        Dimanche: false,
    });

    const [offerTitle, setOfferTitle] = useState("Nom de l'offre pré créée");

    const missionOptions = ["Sélectionner une offre existante pour pré-remplir","Mission test 1", "Mission test 2"];
    const steps = [
        { id: 1, title: "Qualification" },
        { id: 2, title: "Planning" },
        { id: 3, title: "Validation" },
        { id: 4, title: "Confirmation" },
    ];

    const qualificationOptions = [
        { id: 1, title: "Agent de nettoyage H/F" },
        { id: 2, title: "Chauffeur H/F" },
        { id: 3, title: "Préparateur de commande" }
    ];

    const companyAddress = "Entrepôt St Denis 122 boulevard de Corbeilles, 75017 Paris";

    const hoursOptions = Array.from({ length: 24 }, (_, i) => `${String(i).padStart(2, '0')}h`);
    const minutesOptions = ["00m", "15m", "30m", "45m"];
    const daysOfWeek = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

    const handleMissionSelect = (value) => {
        setChosedMission(value);
        setMissionDropdownOpen(false);
    };

    const handleQualificationSelect = (title) => {
        setSelectedQualification(title);
    };

    const handleAddressTypeChange = (type) => {
        setSelectedAddress(type);
    };

    const handleWorkingDayChange = (day) => {
        setWorkingDays(prev => ({ ...prev, [day]: !prev[day] }));
    };

    const handleTimeSelect = (setter, dropdownSetter, value) => {
        setter(value);
        if (dropdownSetter) dropdownSetter(false);
    };

    const handleStartDateChange = (dateData) => {
        setMissionStartDate(dateData.selectedDate);
    };

    const handleEndDateChange = (dateData) => {
        setMissionEndDate(dateData.selectedDate);
    };

    const handleNextStep = () => {
        if (activeStep === 3) {
            console.log("Validation finale et soumission...");
            setActiveStep(4);
            setShowConfirmation(true);
        } else if (activeStep < 3) {
            setDirection('next');
            setPreviousStep(activeStep);
            setIsTransitioning(true);
            
            setTimeout(() => {
                setActiveStep(prevStep => prevStep + 1);
                
                setTimeout(() => {
                    setIsTransitioning(false);
                }, 500);
            }, 50);
        }
    };

    const handlePreviousStep = () => {
        if (activeStep > 1) {
            setDirection('prev');
            setPreviousStep(activeStep);
            setIsTransitioning(true);
            
            setTimeout(() => {
                setActiveStep(prevStep => prevStep - 1);
                
                setTimeout(() => {
                    setIsTransitioning(false);
                }, 500);
            }, 50);
        }
    };

    const renderReadOnlyField = (value, iconClass = null, isTextArea = false) => (
        <div className={`mcf-readonly-field ${isTextArea ? 'textarea' : ''}`}>
            {value}
            {iconClass && <i className={`${iconClass} mcf-readonly-icon`}></i>}
        </div>
    );

    const renderTimeDropdownInternal = (label, value, setter, options, isOpen, dropdownSetter, disabled = false) => (
        <div className="mcf-time-group">
            {label && <label>{label}</label>}
            <div className="custom-dropdown" onClick={() => !disabled && dropdownSetter(!isOpen)}>
                <button
                    type="button"
                    className="custom-dropdown-button time-dropdown-button"
                    disabled={disabled}
                    aria-disabled={disabled}
                >
                    {value}
                    <i className={`fa-solid fa-chevron-down ${isOpen && !disabled ? "rotate" : ""}`}></i>
                </button>
                {isOpen && !disabled && (
                    <ul className="custom-dropdown-menu time-dropdown-menu">
                        {options.map((option) => (
                            <li
                                key={option}
                                onClick={() => handleTimeSelect(setter, dropdownSetter, option)}
                                className={`custom-dropdown-item ${value === option ? "active" : ""}`}
                            >
                                {option}
                                {value === option && <i className="fa-solid fa-check check-icon"></i>}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );

    return (
        <section className="mcf-layout">
            <h1>Nouvelle mission</h1>
            <div className="custom-dropdown" onClick={() => setMissionDropdownOpen(!missionDropdownOpen)}>
                <button type="button" className="custom-dropdown-button">
                    {chosedMission}
                    <i className={`fa-solid fa-chevron-down ${missionDropdownOpen ? "rotate" : ""}`}></i>
                </button>

                {missionDropdownOpen && (
                    <ul className="custom-dropdown-menu">
                        {missionOptions.map((option) => (
                            <li
                                key={option}
                                onClick={() => handleMissionSelect(option)}
                                className={`custom-dropdown-item ${
                                    chosedMission === option ? "active" : ""
                                }`}
                            >
                                {option}
                                {chosedMission === option && (
                                    <i className="fa-solid fa-check check-icon"></i>
                                )}
                            </li>
                        ))}
                    </ul>
                )}
            </div>

            <div className="mcf-progress-bar">
                {steps.map((step) => (
                    <div key={step.id} className={`mcf-step ${activeStep === step.id ? 'active' : ''}`}>
                        <span>Étape {step.id}</span>
                        <i className="fa-solid fa-chevron-right fa-xs"></i>
                        <span>{step.title}</span>
                    </div>
                ))}
            </div>

            <div className="mcf-step-content-container">
                {isTransitioning && previousStep === 1 && (
                    <div className={`mcf-step-content mcf-step-content-exit ${direction === 'next' ? 'exit-to-left' : 'exit-to-right'}`}>
                        <div className="mcf-section">
                            <h2>Étape 1</h2>
                            <h3>Selection de la qualification</h3>
                            <p>Sélectionnez la qualification souhaitée pour la mission :</p>
                            
                            <div className="mcf-qualification-grid">
                                {[...Array(3)].map((_, columnIndex) => (
                                    <div key={columnIndex} className="mcf-qualification-column">
                                        {qualificationOptions.map((option) => (
                                            <div key={`${columnIndex}-${option.id}`} className="mcf-qualification-option">
                                                <input
                                                    type="radio"
                                                    id={`qual-${columnIndex}-${option.id}`}
                                                    name={`qualification-${columnIndex}`}
                                                    checked={selectedQualification === option.title}
                                                    onChange={() => handleQualificationSelect(option.title)}
                                                />
                                                <label htmlFor={`qual-${columnIndex}-${option.id}`}>
                                                    {option.title}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="mcf-section">
                            <h3>Choix du lieu de la prestation</h3>
                            <p>Choisissez l'adresse souhaitée pour la mission :</p>

                            <div className="mcf-address-options">
                                <div className="mcf-address-option">
                                    <input
                                        type="radio"
                                        id="company-address"
                                        name="address-type"
                                        checked={selectedAddress === "company"}
                                        onChange={() => handleAddressTypeChange("company")}
                                    />
                                    <label htmlFor="company-address">
                                        Adresse de votre entreprise : {companyAddress}
                                    </label>
                                </div>

                                <div className="mcf-address-option">
                                    <input
                                        type="radio"
                                        id="custom-address"
                                        name="address-type"
                                        checked={selectedAddress === "custom"}
                                        onChange={() => handleAddressTypeChange("custom")}
                                    />
                                    <label htmlFor="custom-address">
                                        Adresse personnalisée
                                    </label>
                                </div>

                                <div className={`mcf-custom-address-form ${selectedAddress !== 'custom' ? 'disabled' : ''}`}>
                                    <div className="mcf-form-group">
                                        <label>Lieu</label>
                                        <input
                                            type="text"
                                            value={customAddress.lieu}
                                            onChange={(e) => setCustomAddress({...customAddress, lieu: e.target.value})}
                                            disabled={selectedAddress !== 'custom'}
                                        />
                                    </div>
                                    <div className="mcf-form-group">
                                        <label>Adresse</label>
                                        <input
                                            type="text"
                                            value={customAddress.adresse}
                                            onChange={(e) => setCustomAddress({...customAddress, adresse: e.target.value})}
                                            disabled={selectedAddress !== 'custom'}
                                        />
                                    </div>
                                    <div className="mcf-form-row">
                                        <div className="mcf-form-group">
                                            <label>Code postal</label>
                                            <input
                                                type="text"
                                                value={customAddress.codePostal}
                                                onChange={(e) => setCustomAddress({...customAddress, codePostal: e.target.value})}
                                                disabled={selectedAddress !== 'custom'}
                                            />
                                        </div>
                                        <div className="mcf-form-group">
                                            <label>Ville</label>
                                            <input
                                                type="text"
                                                value={customAddress.ville}
                                                onChange={(e) => setCustomAddress({...customAddress, ville: e.target.value})}
                                                disabled={selectedAddress !== 'custom'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                
                {(activeStep === 1 || (isTransitioning && previousStep === 2 && direction === 'prev')) && (
                    <div className={`mcf-step-content ${isTransitioning && direction === 'prev' ? 'mcf-step-content-enter' : ''}`}>
                        <div className="mcf-section">
                            <h2>Étape 1</h2>
                            <h3>Selection de la qualification</h3>
                            <p>Sélectionnez la qualification souhaitée pour la mission :</p>
                            
                            <div className="mcf-qualification-grid">
                                {[...Array(3)].map((_, columnIndex) => (
                                    <div key={columnIndex} className="mcf-qualification-column">
                                        {qualificationOptions.map((option) => (
                                            <div key={`${columnIndex}-${option.id}`} className="mcf-qualification-option">
                                                <input
                                                    type="radio"
                                                    id={`qual-${columnIndex}-${option.id}`}
                                                    name={`qualification-${columnIndex}`}
                                                    checked={selectedQualification === option.title}
                                                    onChange={() => handleQualificationSelect(option.title)}
                                                />
                                                <label htmlFor={`qual-${columnIndex}-${option.id}`}>
                                                    {option.title}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="mcf-section">
                            <h3>Choix du lieu de la prestation</h3>
                            <p>Choisissez l'adresse souhaitée pour la mission :</p>

                            <div className="mcf-address-options">
                                <div className="mcf-address-option">
                                    <input
                                        type="radio"
                                        id="company-address"
                                        name="address-type"
                                        checked={selectedAddress === "company"}
                                        onChange={() => handleAddressTypeChange("company")}
                                    />
                                    <label htmlFor="company-address">
                                        Adresse de votre entreprise : {companyAddress}
                                    </label>
                                </div>

                                <div className="mcf-address-option">
                                    <input
                                        type="radio"
                                        id="custom-address"
                                        name="address-type"
                                        checked={selectedAddress === "custom"}
                                        onChange={() => handleAddressTypeChange("custom")}
                                    />
                                    <label htmlFor="custom-address">
                                        Adresse personnalisée
                                    </label>
                                </div>

                                <div className={`mcf-custom-address-form ${selectedAddress !== 'custom' ? 'disabled' : ''}`}>
                                    <div className="mcf-form-group">
                                        <label>Lieu</label>
                                        <input
                                            type="text"
                                            value={customAddress.lieu}
                                            onChange={(e) => setCustomAddress({...customAddress, lieu: e.target.value})}
                                            disabled={selectedAddress !== 'custom'}
                                        />
                                    </div>
                                    <div className="mcf-form-group">
                                        <label>Adresse</label>
                                        <input
                                            type="text"
                                            value={customAddress.adresse}
                                            onChange={(e) => setCustomAddress({...customAddress, adresse: e.target.value})}
                                            disabled={selectedAddress !== 'custom'}
                                        />
                                    </div>
                                    <div className="mcf-form-row">
                                        <div className="mcf-form-group">
                                            <label>Code postal</label>
                                            <input
                                                type="text"
                                                value={customAddress.codePostal}
                                                onChange={(e) => setCustomAddress({...customAddress, codePostal: e.target.value})}
                                                disabled={selectedAddress !== 'custom'}
                                            />
                                        </div>
                                        <div className="mcf-form-group">
                                            <label>Ville</label>
                                            <input
                                                type="text"
                                                value={customAddress.ville}
                                                onChange={(e) => setCustomAddress({...customAddress, ville: e.target.value})}
                                                disabled={selectedAddress !== 'custom'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {activeStep === 2 && (
                <div className="mcf-step-content">
                    <div className="mcf-section">
                        <h2>Étape 2</h2>
                        <h3>Définissez les détails du planning pour cette mission :</h3>

                        <div className="mcf-form-row mcf-date-row">
                            <div className="mcf-form-group">
                                <label>Date de début de la mission :</label>
                                <DateRangePicker
                                    mode="single"
                                    onChange={handleStartDateChange}
                                />
                            </div>
                            <div className="mcf-form-group">
                                <label>Date de fin de la mission :</label>
                                <DateRangePicker
                                    mode="single"
                                    onChange={handleEndDateChange}
                                />
                            </div>
                        </div>

                        <h3 className="mcf-section-subtitle">Horaires de travail :</h3>
                        <div className="mcf-time-section">
                            <div className="mcf-time-block">
                                {renderTimeDropdownInternal("Heure de début de mission :", startTimeHour, setStartTimeHour, hoursOptions, startTimeHourOpen, setStartTimeHourOpen)}
                                {renderTimeDropdownInternal("", startTimeMinute, setStartTimeMinute, minutesOptions, startTimeMinuteOpen, setStartTimeMinuteOpen)}
                            </div>
                            <div className="mcf-time-block">
                                {renderTimeDropdownInternal("Heure de fin de la mission :  ", endTimeHour, setEndTimeHour, hoursOptions, endTimeHourOpen, setEndTimeHourOpen)}
                                {renderTimeDropdownInternal("", endTimeMinute, setEndTimeMinute, minutesOptions, endTimeMinuteOpen, setEndTimeMinuteOpen)}
                            </div>
                        </div>

                        <h3 className="mcf-section-subtitle">Jours travaillés</h3>
                        <p>Cochez les jours où la mission aura lieu :</p>
                        <div className="mcf-working-days">
                            {daysOfWeek.map(day => (
                                <div key={day} className="mcf-checkbox-option">
                                    <input
                                        type="checkbox"
                                        id={`day-${day}`}
                                        checked={workingDays[day]}
                                        onChange={() => handleWorkingDayChange(day)}
                                    />
                                    <label htmlFor={`day-${day}`}>{day}</label>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {(activeStep === 3 || activeStep === 4) && (
                <div className="mcf-step-content">
                    <div className="mcf-section">
                        <h2>Étape 3</h2>
                        <h3>Validation de l'offre</h3>
                        <p>Avant de valider l'offre, veuillez vérifier et compléter les informations suivantes :</p>
                        <h4>Détails de l'offre sélectionnée</h4>

                        <div className="mcf-validation-grid">
                            <div className="mcf-validation-column">
                                <div className="mcf-form-group mcf-w-65">
                                    <label htmlFor="offer-title">Intitulé de l'offre</label>
                                    <input
                                        type="text"
                                        id="offer-title"
                                        className="mcf-input-highlight"
                                        value={offerTitle}
                                        onChange={(e) => setOfferTitle(e.target.value)}
                                    />
                                </div>
                                <div className="mcf-form-group mcf-w-65">
                                    <label>Qualification requise</label>
                                    {renderReadOnlyField(selectedQualification, 'fa-solid fa-chevron-down')}
                                </div>
                                <div className="mcf-form-group">
                                    <label>Lieu</label>
                                    {renderReadOnlyField(selectedAddress === 'company' ? companyAddress.split(" ")[0] + " " + companyAddress.split(" ")[1] : customAddress.lieu)}
                                </div>
                                <div className="mcf-form-group">
                                    <label>Adresse</label>
                                    {renderReadOnlyField(selectedAddress === 'company' ? companyAddress.split(",")[1]?.trim() : customAddress.adresse, null, true)}
                                </div>
                            </div>

                            <div className="mcf-validation-column">
                                <div className="mcf-form-row">
                                    <div className="mcf-form-group">
                                        <label>Date de début de la mission :</label>
                                        {renderReadOnlyField(formatDate(missionStartDate), 'fa-regular fa-calendar-days')}
                                    </div>
                                    <div className="mcf-form-group">
                                        <label>Date de fin de la mission :</label>
                                        {renderReadOnlyField(formatDate(missionEndDate), 'fa-regular fa-calendar-days')}
                                    </div>
                                </div>
                                <div className="mcf-form-row mcf-time-section">
                                    <div className="mcf-time-block">
                                        {renderTimeDropdownInternal("Heure de début de la mission :", startTimeHour, () => {}, [], false, () => {}, true)}
                                        {renderTimeDropdownInternal("", startTimeMinute, () => {}, [], false, () => {}, true)}
                                    </div>
                                    <div className="mcf-time-block">
                                        {renderTimeDropdownInternal("Heure de fin de la mission :", endTimeHour, () => {}, [], false, () => {}, true)}
                                        {renderTimeDropdownInternal("", endTimeMinute, () => {}, [], false, () => {}, true)}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mcf-lower-validation-row">
                             <div className="mcf-working-days-validation-container">
                                <label>Jours travaillés :</label>
                                <div className="mcf-working-days disabled">
                                    {daysOfWeek.map(day => (
                                        <div key={day} className="mcf-checkbox-option">
                                            <input
                                                type="checkbox"
                                                id={`day-val-${day}`}
                                                checked={workingDays[day]}
                                                readOnly
                                                disabled
                                            />
                                            <label htmlFor={`day-val-${day}`}>{day}</label>
                                        </div>
                                    ))}
                                </div>
                             </div>
                             <div className="mcf-postal-docs-group">
                                <div className="mcf-form-row">
                                    <div className="mcf-form-group">
                                        <label>Code postal</label>
                                        {renderReadOnlyField(selectedAddress === 'company' ? companyAddress.split(",")[2]?.trim().split(" ")[0] : customAddress.codePostal)}
                                    </div>
                                    <div className="mcf-form-group">
                                        <label>Ville</label>
                                        {renderReadOnlyField(selectedAddress === 'company' ? companyAddress.split(",")[2]?.trim().split(" ")[1] : customAddress.ville)}
                                    </div>
                                </div>
                                <div className="mcf-form-group mcf-document-upload">
                                    <label>Documents à joindre (optionnel) :</label>
                                    <div className="mcf-document-item">
                                        <span className="mcf-document-icon"></span>
                                        <a href="#" onClick={(e) => e.preventDefault()}>Fiche de poste</a>
                                    </div>
                                    <div className="mcf-document-item">
                                        <span className="mcf-document-icon"></span>
                                        <a href="#" onClick={(e) => e.preventDefault()}>Autres documents pertinents</a>
                                    </div>
                                </div>
                             </div>
                        </div>
                    </div>
                </div>
            )}
            

            <div className="mcf-button-container">
                {activeStep > 1 && activeStep < steps.length && !showConfirmation && (
                     <button className="btn mcf-back-button" onClick={handlePreviousStep}>
                         Retour
                     </button>
                 )}
                {!showConfirmation && (
                    <button className="btn fill green" onClick={handleNextStep}>
                        {activeStep === 3 ? 'Valider' : (activeStep < steps.length -1 ? 'Étape suivante' : 'Terminer')}
                    </button>
                )}
            </div>

            {showConfirmation && (
                <div className="mcf-confirmation-overlay">
                    <div className="mcf-confirmation-popup">
                        <h2>Félicitations !</h2>
                        <p>Votre offre a été enregistrée dans votre espace.<br/>Vous pouvez désormais :</p>
                        <ul>
                            <li><i className="fa-solid fa-arrow-right"></i> La consulter ou la modifier</li>
                            <li><i className="fa-solid fa-arrow-right"></i> L'envoyer à un ou plusieurs intérimaires</li>
                            <li><i className="fa-solid fa-arrow-right"></i> La dupliquer pour créer une nouvelle offre similaire</li>
                        </ul>
                        <button className="btn fill green" onClick={() => navigate('/dashboard')}>
                            Revenir au tableau de bord
                        </button>
                    </div>
                </div>
            )}
        </section>
    );
};

export default MissionCreationForm;